<template>
<div class="help">
  <!--头部导航-->
  <top-nav ref="TopNav"></top-nav>
  <van-nav-bar title="帮助中心" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
    <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
  </van-nav-bar>
  <div class="van-content">
    帮助中心
  </div>
</div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "index",
    components: {
      TopNav
    },
    data (){
      return {
        datas:''
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/help/index.vue